export default __webpack_public_path__ + "static/media/landingPage.e6b572b0.png";